import React from "react";
import * as AlfredoStyles from "../../../styles/global/global";
import * as AlfredoComponents from "../../../components";

const MovimentReport: React.FC = () => {
  return (
    <AlfredoStyles.Container>
      <AlfredoComponents.Breadcrumb />
      <AlfredoStyles.FlexContainer>
        <AlfredoStyles.FlexItem>
          <AlfredoComponents.MovimentReport />
        </AlfredoStyles.FlexItem>
      </AlfredoStyles.FlexContainer>
    </AlfredoStyles.Container>
  );
};

export default MovimentReport;
